export default "__VITE_ASSET__LReyF0N8__"